var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news"},[_c('h1',{staticClass:"title is-2"},[_vm._v(_vm._s(_vm.$t('news.news')))]),_c('VueRssFeed',{attrs:{"feedUrl":_vm.feedUrl,"name":"","limit":5}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }